var skrilla = angular.module('Skrilla-Admin',
    [
        'ngMaterial',
        'ngAnimate',
        'ngResource',
        'ngSanitize',
        'ngAria',
        'ui.router',
        'ui.bootstrap',
        'environment',
        'ui.bootstrap.datetimepicker',
        'ngCsv',
        'monospaced.qrcode',
        'ngFileSaver',
        'angularMoment',
            'viewhead',
        'prettyXml'
    ]
);



